import type { ReactNode } from "react";
import { cn } from "./cn";

/** Top screen strip — shared chrome for Yard / Consortium toolbars. */
export function ScreenToolbar({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex h-11 shrink-0 items-center gap-2.5 border-b border-border-subtle bg-surface px-4",
        className,
      )}
    >
      {children}
    </div>
  );
}

/** Breadcrumb separator between module label and toolbar content. */
export function ScreenToolbarBreadcrumbSep() {
  return (
    <span className="-mx-0.5 text-border-strong" aria-hidden>
      ›
    </span>
  );
}

export function ScreenToolbarSpacer() {
  return <div className="flex-1" />;
}
